import * as React from 'react';

import { Text } from '../../Text';
import { IFlatInfoSchema } from '../../../repositories/favorites/entities/favorite_entity_for_desktop/FlatInfoSchema';

export interface IFlatInfoProps {
  flatInfo: IFlatInfoSchema;
}

export function FlatInfo({ flatInfo }: IFlatInfoProps) {
  const { rentTypeText } = flatInfo;

  return (
    <>
      {rentTypeText && (
        <div>
          <Text textSize="small" color="gray">
            {rentTypeText}
          </Text>
        </div>
      )}
    </>
  );
}
